/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import { Link, useLocation } from "react-router-dom";
import { Menu, MenuItem } from "react-pro-sidebar";
import { Badge, Flex } from "antd";
import { HistoryOutlined } from "@ant-design/icons";
import logo from "../../assets/images/logo_nsf.png";
import nav from "../../nav";

import { Authenticate } from '../../service/Authenticate.service.js';
// import { useAppDispatch } from '../../store/store';

/* ===== Recent menus (cookie) ===== */
const RECENT_COOKIE = "recent_menus";
const RECENT_MAX = 5;

const getRecentCookie = () => {
  try {
    const m = document.cookie.match(new RegExp(`(?:^|;\\s*)${RECENT_COOKIE}=([^;]*)`));
    const list = m ? JSON.parse(decodeURIComponent(m[1])) : [];
    return Array.isArray(list) ? list : [];
  } catch {
    return [];
  }
};

const setRecentCookie = (list) => {
  document.cookie = `${RECENT_COOKIE}=${encodeURIComponent(JSON.stringify(list))};path=/;max-age=${60 * 60 * 24 * 365}`;
};

const Sidenav = () => {
  const authService =  Authenticate();
  // const [ waitApprove, setWaitAppreve ] = useState(0);
  // const dispatch = useAppDispatch();
  
  const { pathname } = useLocation();
  const [recent, setRecent] = useState(getRecentCookie());

  useEffect(() => {
    // match the most specific nav item for the current path
    const matched = nav
      .filter((n) => n?.to && pathname.startsWith(n.to))
      .sort((a, b) => b.to.length - a.to.length)[0];
    if (!matched) return;
    const list = [
      matched.to,
      ...getRecentCookie().filter((t) => t !== matched.to),
    ].slice(0, RECENT_MAX);
    setRecentCookie(list);
    setRecent(list);
  }, [pathname]);

  const recentItems = recent
    .map((to) => nav.find((n) => n?.to === to))
    .filter(Boolean);

  const navActiveStyle = {
    padding: "10px 16px",
    color: "#141414",
    borderRadius: "8px",
    backgroundColor: "#fff",
    boxShadow: "0 20px 27px rgba(0,0,0,.05)",
  }

  const Notification = ( {title}) => {
    // console.log(title);
    switch(title){
      case "Sample Preparation" :
        return (
          <Badge dot={ authService.getType() === 'admin'  } size="small" offset={[1, 2]}> 
            <span>
              {title} 
            </span>
          </Badge>
        );
      default: return (<><span>{title}</span></>)
    }
  }
  return (
    <>
      <Flex vertical className="brand width-100" justify='center' align='center' >
        <img src={logo} alt="9star logo" style={{width:110, height:100}}  />
        <span>TIDMUN</span>
      </Flex>
      <hr />

      {/* <Sidebar style={{minWidth:"100%", width:"100%"}} > */}
        <Menu theme="light" mode="inline">
          {recentItems.length > 0 && (
            <>
              <MenuItem className="nav-group-title">
                <HistoryOutlined style={{ marginRight: 4 }} />
                ล่าสุด
              </MenuItem>
              {recentItems.map((item) => (
                <MenuItem
                  icon={item?.icon}
                  key={`recent-${item.to}`}
                  component={<Link to={item.to} />}
                  className={pathname.startsWith(item.to) ? "nav-active" : null}
                >
                  <Notification title={item?.title} />
                </MenuItem>
              ))}
            </>
          )}
          {nav.map((item, idx) => {
            return ( !item?.type ? (
              <MenuItem
                icon={item?.icon}
                key={idx}
                component={ <Link to={item?.to} style={{navActiveStyle}} /> }
                className={pathname.startsWith(item?.to)? "nav-active" : null}
              > 
                <Notification title={item?.title} />
              </MenuItem>
            ) : (
              <MenuItem key={idx} className="nav-group-title">
                {item?.title}
              </MenuItem>
            )
            );
          })}
        </Menu>
      {/* </Sidebar> */}
    </>
  );
};

export default Sidenav;
